import styled, { css, keyframes } from 'styled-components';
import {
  InsightsCardDesktop,
  InsightsCardMobile,
  InsightsContainerDesktop,
  InsightsWrapperDesktop,
  InsightsContainerMobile,
  InsightsWrapperMobile,
} from '../SmartInsights.styles';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const skeletonBackground = css`
  background: linear-gradient(90deg, #f4f4f4 0%, #ededed 50%, #f4f4f4 100%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export const SkeletonWrapperDesktop = styled(InsightsWrapperDesktop)`
  pointer-events: none;
`;

export const SkeletonContainer = styled(InsightsContainerDesktop)`
  min-width: 0;
`;

export const SkeletonCard = styled(InsightsCardDesktop)`
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.02), 0 0 8px 0 rgba(0, 0, 0, 0.08);
`;

export const SkeletonHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

export const SkeletonIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 16px;
  ${skeletonBackground}
`;

export const SkeletonTitle = styled.div<{ $width?: string }>`
  height: 20px;
  width: ${({ $width }) => $width || '50%'};
  border-radius: 10px;
  ${skeletonBackground}
`;

export const SkeletonBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkeletonLine = styled.div<{ $width?: string }>`
  height: 14px;
  width: ${({ $width }) => $width || '100%'};
  border-radius: 8px;
  ${skeletonBackground}
`;

export const SkeletonWrapperMobile = styled(InsightsWrapperMobile)`
  pointer-events: none;
`;

export const SkeletonContainerMobile = styled(InsightsContainerMobile)`
  min-width: 0;
`;

export const SkeletonCardMobile = styled(InsightsCardMobile)`
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.02), 0 0 8px 0 rgba(0, 0, 0, 0.08);
  min-height: 160px;
`;
